import classNames from "classnames";
import { isNil } from "lodash";
import React from "react";

import { WorkforceCalendarData } from "../../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../../context/bookings_overview_context";
import { useUtilizationDataProvider } from "../../../workforce_metrics";
import HeatMapItem from "../heat_map_row/heat_map_item";
import { HeatMap } from "../heat_map_row/heat_map_item.types";
import css from "./utilization_item.module.scss";

const BORDER_WIDTH = 1;

type UtilizationItemProps = {
  items: HeatMap[];
};

export const UtilizationItem = ({ items }: UtilizationItemProps): JSX.Element => {
  const {
    calendarData: { thresholds }
  } = useBookingsOverviewContext<WorkforceCalendarData>();

  const firstItem = items[0];
  const fullWidth = firstItem.width * items.length - BORDER_WIDTH;
  const { getUtilizationValue, getUtilizationLabel, getBackgroundColor } = useUtilizationDataProvider();
  const utilizationValue = getUtilizationValue(firstItem);
  const utilizationLabel = getUtilizationLabel(utilizationValue);

  return (
    <HeatMapItem
      {...firstItem}
      left={firstItem.left}
      width={fullWidth}
      rootClassName={css.utilizationItem}
      labelClassName={classNames(css.label)}
      label={utilizationLabel ?? ""}
      bgColor={
        !isNil(utilizationValue) ? getBackgroundColor(utilizationValue, thresholds.heatmap) : undefined
      }
      shouldDisplayLabel={
        !isNil(utilizationValue) &&
        ((utilizationValue < 10 && fullWidth > 45) || (utilizationValue >= 10 && fullWidth > 55))
      }
    />
  );
};
